// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import moment from "moment";

// import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
// import useApiRequest from "../../../../Hooks/apiReq";
// import { convertToINRFormat } from "../../../../Utils/INRConvert";
// import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
// import { APP_VERSION } from "../../../../Utils/AppVersion";

// // Recharts
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   CartesianGrid,
//   LabelList,
// } from "recharts";

// // Icons
// import { FaRupeeSign, FaMedal, FaUserTie, FaUsers } from "react-icons/fa";

// // MOCK (First Load)
// const mockCommissionData = {
//   Response: {
//     AssoTotalCommission: 120000,
//     AssociateRank: "Gold",
//     TotalSelfBusinessCommission: 30000,
//     TotalTeamBusinessCommission: 90000,
//     TotalCommission: 120000,
//     MonthlyCommission: [
//       {
//         Month: "Jan",
//         SelfCommission: 6000,
//         TeamCommission: 14000,
//         TotalCommission: 20000,
//       },
//       {
//         Month: "Feb",
//         SelfCommission: 7000,
//         TeamCommission: 16000,
//         TotalCommission: 23000,
//       },
//       {
//         Month: "Mar",
//         SelfCommission: 28000,
//         TeamCommission: 18000,
//         TotalCommission: 46000,
//       },
//       {
//         Month: "Apr",
//         SelfCommission: 558000,
//         TeamCommission: 18000,
//         TotalCommission: 576000,
//       },
//       {
//         Month: "May",
//         SelfCommission: 258000,
//         TeamCommission: 18000,
//         TotalCommission: 276000,
//       },
//       {
//         Month: "Jun",
//         SelfCommission: 12000,
//         TeamCommission: 148000,
//         TotalCommission: 160000,
//       },
//       {
//         Month: "Jul",
//         SelfCommission: 48000,
//         TeamCommission: 18000,
//         TotalCommission: 66000,
//       },
//       {
//         Month: "Aug",
//         SelfCommission: 58000,
//         TeamCommission: 18000,
//         TotalCommission: 76000,
//       },
//       {
//         Month: "Sep",
//         SelfCommission: 98000,
//         TeamCommission: 18000,
//         TotalCommission: 116000,
//       },
//       {
//         Month: "Oct",
//         SelfCommission: 8000,
//         TeamCommission: 18000,
//         TotalCommission: 26000,
//       },
//       {
//         Month: "Nov",
//         SelfCommission: 8000,
//         TeamCommission: 18000,
//         TotalCommission: 26000,
//       },
//       {
//         Month: "Dec",
//         SelfCommission: 8000,
//         TeamCommission: 18000,
//         TotalCommission: 26000,
//       },
//     ],
//   },
// };

// const Commision = () => {
//   const { loading, sendApiRequest } = useApiRequest();

//   const [response, setResponse] = useState({});
//   const [monthlyData, setMonthlyData] = useState([]);

//   const now = new Date();
//   const [FromDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
//   const [ToDate] = useState(new Date());
//   const [previous, setPrevious] = useState({ fromdate: null, todate: null });

//   const animateNumber = (value) => {
//     if (!value) return "0";
//     return convertToINRFormat(value);
//   };

//   const fetchComissionDetails = (from, to) => {
//     if (
//       JSON.stringify(previous) ===
//       JSON.stringify({ fromdate: from, todate: to })
//     ) {
//       toast.info("There is no change in the date", { toastId: "commission" });
//       return;
//     }

//     if (!from || !to) {
//       toast.warn("Please select date", { toastId: "commission" });
//       return;
//     }

//     const formattedFromDate = moment(from).format("DD-MM-YYYY");
//     const formattedToDate = moment(to).format("DD-MM-YYYY");

//     sendApiRequest(
//       "POST",
//       "/Dashboard/GetBussinessCommisionRankDetails",
//       {
//         FromDate: formattedFromDate,
//         ToDate: formattedToDate,
//         DeviceType: "Web",
//         AppVersion: APP_VERSION,
//         action: "Commission",
//       },
//       {
//         onSuccess: (res) => {
//           setResponse(res?.data);
//           const monthlyBusiness = res?.data?.monthwiseJson
//             ? JSON.parse(res?.data?.monthwiseJson)
//             : [];
//           console.log(monthlyBusiness, "monthlyBusiness");
//           setMonthlyData(monthlyBusiness);
//           setPrevious({ fromdate: from, todate: to });
//         },
//       }
//     );
//   };

//   return (
//     <div className="col-12 col-xl-6 col-xxl-6" style={{ position: "relative" }}>
//       {loading && <SpinnerLoader />}

//       <div className="card border h-100 w-100 overflow-hidden">
//         <div className="card-body p-2 ucbd-head">
//           <div className="row">
//             <div class="col-lg-3">
//               <h4 className="mt-2 fs-8">
//                 <span className="fas fa-building"></span> Commission
//               </h4>
//             </div>
//             <div class="col-lg-9 col-sm-auto">
//               <div class="row g-2">
//                 <DateFilterBar onGo={fetchComissionDetails} />
//               </div>
//             </div>
//           </div>
//           {
//             <div class="ucb-details">
//               <div class="ucb-current">
//                 <div class="ucb-left">
//                   <b>{convertToINRFormat(response?.assoTotalCommission)}</b>
//                   <span>Total Commission</span>
//                 </div>
//                 <div class="ucb-right">
//                   <b>{response?.associateRank}</b>
//                   <span>Current Rank</span>
//                 </div>
//               </div>
//               <div class="ucb-duration">Commission in Duration</div>
//               <div class="ucb-list">
//                 <b> Self Business Commission (S.B.C.)</b>
//                 <span>
//                   {convertToINRFormat(response?.totalSelfBusinessCommission)}
//                 </span>
//               </div>
//               <div class="ucb-list">
//                 <b>Team Business Commission (T.B.C.)</b>
//                 <span>
//                   {convertToINRFormat(response?.totalTeamBusinessCommission)}
//                 </span>
//               </div>
//               <div class="ucb-list">
//                 <b>Total Commission</b>
//                 <span>{convertToINRFormat(response?.totalCommission)}</span>
//               </div>
//             </div>
//           }
//         </div>
//       </div>
//     </div>
//   );
// };

// export default React.memo(Commision);

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";

import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
import useApiRequest from "../../../../Hooks/apiReq";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { APP_VERSION } from "../../../../Utils/AppVersion";

// Icons

import { IoIosBusiness } from "react-icons/io";

const Commision = () => {
  const { loading, sendApiRequest } = useApiRequest();

  const [response, setResponse] = useState({});
  const [monthlyData, setMonthlyData] = useState([]);

  // --- NEW STATE FOR VISIBILITY ---
  const [isVisible, setIsVisible] = useState(false);

  const now = new Date();
  const [FromDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
  const [ToDate] = useState(new Date());
  const [previous, setPrevious] = useState({ fromdate: null, todate: null });

  // Helper function to handle masking
  // const renderAmount = (value) => {
  //   if (!isVisible) {
  //     // Convert to string, remove decimal/commas if any, and replace digits
  //     const strValue = (parseInt(value) ?? 0).toString();
  //     return "₹" + strValue.replace(/\d/g, "*");
  //   }
  //   return convertToINRFormat(value ?? 0);
  // };
  const renderAmount = (value) => {
    const amount = value?.toString() || "0";

    if (isVisible) {
      return convertToINRFormat(amount);
    }

    const length = Math.max(3, amount.length);

    return "₹ " + "*".repeat(length);
  };

  const fetchComissionDetails = (from, to) => {
    if (
      JSON.stringify(previous) ===
      JSON.stringify({ fromdate: from, todate: to })
    ) {
      toast.info("There is no change in the date", { toastId: "commission" });
      return;
    }

    if (!from || !to) {
      toast.warn("Please select date", { toastId: "commission" });
      return;
    }

    const formattedFromDate = moment(from).format("DD-MM-YYYY");
    const formattedToDate = moment(to).format("DD-MM-YYYY");

    sendApiRequest(
      "POST",
      "/Dashboard/GetBussinessCommisionRankDetails",
      {
        FromDate: formattedFromDate,
        ToDate: formattedToDate,
        DeviceType: "Web",
        AppVersion: APP_VERSION,
        action: "Commission",
      },
      {
        onSuccess: (res) => {
          setResponse(res?.data);
          const monthlyBusiness = res?.data?.monthwiseJson
            ? JSON.parse(res?.data?.monthwiseJson)
            : [];
          setMonthlyData(monthlyBusiness);
          setPrevious({ fromdate: from, todate: to });
        },
      },
    );
  };

  return (
    <div className="col-12 col-xl-6 col-xxl-6" style={{ position: "relative" }}>
      {loading && <SpinnerLoader />}

      <div className="card border h-100 w-100 overflow-hidden shadow-sm">
        <div className="card-body p-2 ucbd-head">
          <div className="row">
            <div className="col-lg-3">
              <h4 className="mt-2 fs-8">
                <span className="fas fa-building"></span>{" "}
                <IoIosBusiness size={20} />
                Commission
              </h4>
            </div>
            <div className="col-lg-9 col-sm-auto">
              <div className="row g-2">
                <DateFilterBar onGo={fetchComissionDetails} />
              </div>
            </div>
          </div>

          {/* Wrapper with onClick to toggle visibility */}
          <div className="ucb-details mt-3" style={{ cursor: "pointer" }}>
            <div className="ucb-current">
              <div className="ucb-left">
                <b onClick={() => setIsVisible(!isVisible)}>
                  {renderAmount(response?.assoTotalCommission)}
                </b>
                <span>Total Commission</span>
              </div>
              <div className="ucb-right">
                <b className="fw-bold">{response?.associateRank || "--"}</b>
                <span>Current Rank</span>
              </div>
            </div>

            <div className="ucb-duration headingColor">
              {" "}
              <span>Commission in Duration</span>
              {/* Dynamic Eye Icon */}
            </div>

            <div className="ucb-list">
              <b>Self Business Commission (S.B.C.)</b>
              <span
                className="textColor"
                onClick={() => setIsVisible(!isVisible)}
              >
                {renderAmount(response?.totalSelfBusinessCommission)}
              </span>
            </div>

            <div className="ucb-list">
              <b>Team Business Commission (T.B.C.)</b>
              <span
                className="textColor"
                onClick={() => setIsVisible(!isVisible)}
              >
                {renderAmount(response?.totalTeamBusinessCommission)}
              </span>
            </div>

            <div className="ucb-list">
              <b>Total Commission</b>
              <span
                className="textColor"
                onClick={() => setIsVisible(!isVisible)}
              >
                {renderAmount(response?.totalCommission)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Commision);
